// eslint-disable-next-line import/prefer-default-export
export const Collections = Object.freeze({
  Users: 'users',
  Dealerships: 'dealerships',
});
